var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position resource-list-item",class:{ 'is-dark': _vm.$themeDark }},[_c('div',{staticClass:"position-title"},[_vm._v(" "+_vm._s(_vm.position.lat.toFixed(6))+", "+_vm._s(_vm.position.lng.toFixed(6))),_c('br'),_vm._v(" "+_vm._s(_vm.position.createdAt.format(_vm.system.settings.datetimeFormat))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }